export const CAMPAIGN_STATUSES = [
  "Consultation",
  "Confirmed",
  "In Progress",
  "Billing",
  "Completed"
] as const;

export type CampaignStatus = typeof CAMPAIGN_STATUSES[number];

export const DELIVERABLE_STATUSES = [
  "Draft",
  "Production",
  "Delivered",
  "Approved",
  "Rejected",
  "Published"
] as const;

export type DeliverableStatus = typeof DELIVERABLE_STATUSES[number];

export const statusOrder: Record<CampaignStatus, number> = {
  "Consultation": 0,
  "Confirmed": 1,
  "In Progress": 2,
  "Billing": 3,
  "Completed": 4
};

export const maxStatus = (a: CampaignStatus, b: CampaignStatus): CampaignStatus =>
  statusOrder[a] >= statusOrder[b] ? a : b;

export interface StatusChangeReason {
  fromStatus: CampaignStatus;
  toStatus: CampaignStatus;
  messageKey: string;
}

// Known transitions with a specific toast message; anything else falls back
// to the generic statusToast.statusChanged copy.
export const STATUS_CHANGE_REASONS: StatusChangeReason[] = [
  { fromStatus: "Consultation", toStatus: "Confirmed", messageKey: "statusToast.toConfirmed" },
  { fromStatus: "Consultation", toStatus: "In Progress", messageKey: "statusToast.toInProgress" },
  { fromStatus: "Confirmed", toStatus: "In Progress", messageKey: "statusToast.toInProgress" },
  { fromStatus: "In Progress", toStatus: "Billing", messageKey: "statusToast.toBilling" },
  { fromStatus: "Billing", toStatus: "Completed", messageKey: "statusToast.toCompleted" }
];
